/**
 * Runtime configuration, written by the image entrypoint into
 * /usr/share/nginx/html/env.js (see intermal/Dockerfile.frontend,
 * 40-render-env-js.sh) and loaded by public/index.html BEFORE the
 * deferred main bundle. Lets one image serve any Comm installation's
 * hostname without a rebuild.
 *
 * Same shape as ausschreibungsmatcher/client/src/types/runtimeEnv.ts.
 */
export interface RuntimeEnv {
  API_BASE_URL: string;
  OIDC_ISSUER_URL: string;
  OIDC_CLIENT_ID: string;
  OIDC_REDIRECT_URI: string;
  FRAME_ANCESTORS: string;
  /**
   * Volle URL der Anwenderhandbuch-Seite im Plattform-Wiki (Paket 8). Leer,
   * solange die Installation kein Handbuch verlinkt; siehe src/hilfe/handbuch.ts.
   */
  HANDBUCH_URL: string;
}

declare global {
  interface Window {
    __INTERMAL_ENV__?: Partial<RuntimeEnv>;
  }
}

export function runtimeEnv(): RuntimeEnv {
  const env = window.__INTERMAL_ENV__ ?? {};
  return {
    API_BASE_URL: env.API_BASE_URL ?? '',
    OIDC_ISSUER_URL: env.OIDC_ISSUER_URL ?? '',
    OIDC_CLIENT_ID: env.OIDC_CLIENT_ID ?? 'intermal',
    OIDC_REDIRECT_URI: env.OIDC_REDIRECT_URI ?? '',
    FRAME_ANCESTORS: env.FRAME_ANCESTORS ?? '',
    HANDBUCH_URL: env.HANDBUCH_URL ?? '',
  };
}

/**
 * True when the deployment is wired to Keycloak. Mirrors the backend gate
 * in src/server.ts (`OIDC_ENABLED=true && OIDC_ISSUER_URL`): when this is
 * true the backend rejects every /api call without a Keycloak bearer, so
 * the local e-mail/password form cannot work and must not be offered.
 */
export function isOidcConfigured(): boolean {
  const env = runtimeEnv();
  return Boolean(env.OIDC_ISSUER_URL && env.OIDC_CLIENT_ID);
}
